import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { systemMetadata } from '@mysidewalk/references';

import ColumnAttributionDetails from 'attribution/ColumnAttributionDetails';
import PageNotFound from 'application/PageNotFound';

import 'styles/layouts.css';

const { Column, ColumnDynamicAttribution } = systemMetadata;

const COLUMN_PARAMS = {
  include: 'characteristic_type,time_element',
};

function ColumnShowRoute() {
  const { id } = useParams();

  const query = useQuery(
    ['columns/attribution', id],
    () => (
      Promise.all([
        Column.retrieve(id, COLUMN_PARAMS),
        ColumnDynamicAttribution.retrieve(id),
      ])
    ),
  );

  useEffect(() => {
    if (query.isSuccess) {
      const [column] = query.data;
      const { characteristicType, timeElement } = column;
      document.title = `${characteristicType.friendlyLongName} \u00B7 ${timeElement.friendlyShortName} | mySidewalk Catalog`;
    }
  }, [query]);

  if (query.isError) return <PageNotFound />;

  const [column, attribution] = query.data ?? [];
  const hasLoaded = !!column && !!attribution;
  const header = (
    column
      ? (
        <header className="indicator-summary">
          <h1 className="indicator-summary__title">{column.characteristicType.friendlyLongName}</h1>
          <p className="indicator-summary__metadata">{column.timeElement.friendlyLongName}</p>
        </header>
      )
      : null
  );
  const details = (
    hasLoaded
      ? (
        <ColumnAttributionDetails
          column={column}
          attribution={attribution}
        />
      )
      : null
  );

  return (
    <div className="layout--page">
      {header}
      {details}
    </div>
  );
}

export default ColumnShowRoute;
